const i = {
  /* Image */
  avif: "image/avif",
  bmp: "image/bmp",
  gif: "image/gif",
  ico: "image/vnd.microsoft.icon",
  jpeg: "image/jpeg",
  png: "image/png",
  svg: "image/svg+xml",
  tiff: "image/tiff",
  webp: "image/webp",
  /* PDF */
  pdf: "application/pdf",
  /* Microsoft Word */
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  /* Microsoft Excel */
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  /* CSV */
  csv: "text/csv",
  /* Json */
  json: "application/json",
  jsonld: "application/ld+json",
  /* YAML */
  yaml: "application/x-yaml",
  yml: "application/x-yaml"
}, e = [
  i.avif,
  i.bmp,
  i.gif,
  i.ico,
  i.jpeg,
  i.png,
  i.svg,
  i.tiff,
  i.webp
], p = [i.pdf], o = [i.doc, i.docx], m = [i.xls, i.xlsx], a = [i.csv], c = [i.yaml, i.yml];
export {
  a as CsvMimeType,
  e as ImageMimeType,
  i as MimeTypes,
  m as MsExcelMimeType,
  o as MsWordMimeType,
  p as PdfMimeType,
  c as YAMLMimeType
};
//# sourceMappingURL=mimeTypes.js.map
